export async function apiFetch<T>(url: string): Promise<T> {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`API error ${response.status} ${response.statusText}`)
  }
  const body: unknown = await response.json()
  // Guard against empty/malformed bodies before trusting the shape as T.
  // Full runtime schema validation would need a library (e.g. Zod), which
  // this project does not currently depend on.
  if (body === null || body === undefined) {
    throw new Error(`API error: empty response body from ${url}`)
  }
  return body as T
}

export const serializeIds = (ids: number[]) =>
  [...ids].sort((a, b) => a - b).join(',')
